var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slider',{attrs:{"dense":"","height":"20px","hide-details":"","max":"100","min":"0","small":"","step":"1","thumb-label":""},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})}
var staticRenderFns = []

export { render, staticRenderFns }